module.exports = __webpack_public_path__ + "media/images/about/c_2-12d1cb65b8a353da993060ccd2a717d8.png";